<template>
	<div class="hotspot-scene__hotspot-circle-trigger animate__animated animate__delay-1s animate__fadeIn" :style="`left: ${leftPositionX}%; top: ${topPositionY}%;`" @click="launchModal">
		<span class="ring"></span>
		<span class="circle" :style="`background-color: ${color}`"></span>
	</div>
</template>

<script lang="ts" setup>
const componentName = 'Hotspot';
const emit = defineEmits(['modalVisibilityUpdated', 'updateActiveHotspotIndex']);
interface Window {
	dataLayer?: any[];
}
const props = defineProps({
	leftPositionX: {
		type: String,
		default: "0"
	},
	topPositionY: {
		type: String,
		default: '0'
	},
	displayTitle: {
		type: String,
		default: ''
	},
	modalVisible: {
		type: Boolean,
		default: false
	},
	color: {
		type: String,
		default: ''
	},
	hotspotPlacementsLength: {
		type: Number,
		default: 0
	},
	index: {
		type: Number,
		default: 0
	},
	hotspots: {
		type: Array as () => any[],
		default: []
	}
});

const launchModal = () => {
	emit('updateActiveHotspotIndex', props.index);
	emit('modalVisibilityUpdated', true);

	// Assert the type of window.dataLayer
	//@ts-ignore
	const dataLayer = window.dataLayer as any[];

	// Now TypeScript knows that dataLayer is an array and push method can be called on it
	dataLayer.push({
		'hotspotLeft': props.leftPositionX,
		'hotspotTop': props.topPositionY,
		'hotspotScene': props.displayTitle,
		'hotspotDisplayTitle': props.hotspots[0]?.DisplayTitle,
		'hotspotPage': `${props.index + 1} of ${props.hotspotPlacementsLength}`,
		'event': 'Click Hotspot'
	});
}
const closeModal = () => {
	emit('modalVisibilityUpdated', false);
}
const modalVisibilityUpdated = (value) => {
	emit('modalVisibilityUpdated', value);
}

</script>
